import { useCallback, useEffect, useMemo, useState } from "react";
import { API, Designer, Endpoints } from "@brg/api";
import { useProfile } from "@brg/auth";
import { DesignerTab } from "../constants/designerTab";
import { AppTester } from "../../supporting";
import {
  BASE_COURSE_MODERN_DESIGN_TAG_ID,
  CANTEMPORARY_ART_TAG_ID,
  CINEMA_TAG_ID,
  DIGITAL_ART_TAG_ID,
  EXPORT_PAGE_PROJECTS_GRID_LIMIT,
  FINE_ART_TAG_ID,
  VIDEO_ART_TAG_ID,
  GALLLLERY_ART_DIGITAL_COLLECTIONS_TAG_ID,
  GALLLLERY_ART_COLLECTIONS_TAG_ID,
  GALLLLERY_ART_COLLECTING_TAG_ID,
  GALLLLERY_ART_ABOUT_COLLECTIONS_TAG_ID,
  KIIIDS_ART_PROFILE_TAG_IDS,
} from "../constants/misc";
import {COMPETITION_TYPE, STATUSES} from "../../_competition/const";
import { ModerationType } from "shared/pages/teams/const/ModerationTypes";
import arraysIntersect from "shared/helpers/arraysIntersect";
import { ftblApi } from "../api/ftblApi";
import useAppTester from "shared/MobileMenu/hooks/useAppTester";
import { useGetPersonalizedTag } from "./api/useGetPersonalizedTag";

interface GetTabs {
  id: string, 
  commonFilter: any,  
  superPuperFilter: any , 
  isSuperPuper: boolean, 
  isMe: boolean, 
  isTeacher?: boolean, 
  isAgeyTomesh: boolean, 
  isMedia?: boolean,
  isGalllleryArt?: boolean,
  tagId: string,
  profile?: boolean,
  showcase?: boolean,
  activeTab?: string,
  personalTagId?: string,
  isHseSpace?: boolean,
  isExportPage?: boolean,
  isKiiidsArt?: boolean,
  replaceCompetitionsToPractices?: boolean,
  hasPersonalTags?: boolean,
}

export const getDesignerTabsFilters = (props: GetTabs) => {
  const {
    commonFilter,
    id,
    personalTagId, 
    isMe, 
    isSuperPuper, 
    isTeacher, 
    superPuperFilter, 
    isAgeyTomesh, 
    isMedia,
    isHseSpace,
    isGalllleryArt,
    tagId, 
    profile, 
    showcase, 
    activeTab,
    isExportPage,
    isKiiidsArt,
    replaceCompetitionsToPractices,
    hasPersonalTags,
  } = props

  const galllleryArtTagIds = [
    GALLLLERY_ART_DIGITAL_COLLECTIONS_TAG_ID,
    GALLLLERY_ART_COLLECTIONS_TAG_ID,
    GALLLLERY_ART_COLLECTING_TAG_ID,
    GALLLLERY_ART_ABOUT_COLLECTIONS_TAG_ID
  ];    

  if (isExportPage) {
    return [
      {
        name: DesignerTab.author,
        entityType: 'projects',
        filter: {
          ...commonFilter,
          isMainAuthor: true,
          authorIds: [id],
          projectStatus: [1],
          isContextIgnored: true,
          ...(activeTab === DesignerTab.author && { ...(!!showcase && {
            contexts: isAgeyTomesh ? ['ageytomesh'] : ['hsedesign'],
            isContextIgnored: false,
          })}),
          ...(tagId ? { tagIds: [tagId] } : isGalllleryArt ? { tagIds: galllleryArtTagIds } : {}),
        },
      },
      ...(isMe
        ? [
            {
              name: DesignerTab.private,
              entityType: 'projects',
              filter: {
                ...commonFilter,
                authorIds: [id],
                projectStatus: [10],
                isContextIgnored: true,
                entityType: 'private_projects',
                onlyBooks: '',
              },
            },
          ]
        : []),
    ];
  }

  if (isSuperPuper) {
    return [
      {
        name: DesignerTab.games_archive,
        entityType: 'projects',
        filter: {
          ...superPuperFilter,
          authorIds: [id],
          projectStatus: [1],
          onlyAuthors: true
        }
      },
      ...(isMe ? [{
        name: DesignerTab.games_drafts,
        entityType: 'projects',
        filter: {
          ...superPuperFilter,
          authorIds: [id],
          projectStatus: [0],
          onlyAuthors: true
        }
      }] : [])]
  }

  if (isKiiidsArt) {
    return [
      {
        name: DesignerTab.author,
        entityType: 'projects',
        filter: {
          ...commonFilter,
          authorIds: [id],
          projectStatus: [1],
          isContextIgnored: true,
          tagIds: KIIIDS_ART_PROFILE_TAG_IDS,
        },
      },
      {
        name: DesignerTab.books,
        entityType: 'books',
        filter: {
          ...commonFilter,
          authorIds: [id],
          bookStatus: [1],
          onlyBooks: true,
          isContextIgnored: true,
          tagIds: KIIIDS_ART_PROFILE_TAG_IDS,
        },
      },
    ];
  }

  const profileOrganizationsModerationTypes = [
    ModerationType.Own,
    ModerationType.OwnWithoutTag,
    ModerationType.Outer,
    ModerationType.Standard,
    ModerationType.StandardWithoutTag,
    ModerationType.Hsedesign
  ];

  return [
    {
      name: DesignerTab.author,
      entityType: 'projects',
      filter: {
        ...commonFilter,
        // isContextIgnored: false,
        authorIds: [id],
        // isMainAuthor: true,
        projectStatus: [1],
        isContextIgnored: true,
        ...(activeTab === DesignerTab.author && { ...(!!showcase && {
          contexts: isAgeyTomesh ? ['ageytomesh'] : ['hsedesign'], 
          isContextIgnored: false,
        })}),
        ...(tagId ? { tagIds: [tagId] } : isGalllleryArt ? { tagIds: galllleryArtTagIds } : {})
      }
    },
    ...(isTeacher ? [{
      name: DesignerTab.students,
      entityType: 'projects',
      filter: {
        ...commonFilter,
        curatorsIdList: [id],
        projectStatus: [1],
        isContextIgnored: true,
        ...(activeTab === DesignerTab.students && { ...(!!showcase && {
          contexts: isAgeyTomesh ? ['ageytomesh'] : ['hsedesign'], 
          isContextIgnored: false,
        })}),
      }
    }
    ] : []),
    {
      name: DesignerTab.books,
      entityType: 'books',
      filter: {
        ...commonFilter,
        authorIds: [id],
        bookStatus: [1],
        onlyBooks: true,
        isContextIgnored: true,
        // ...(isGalllleryArt ? { tagIds: galllleryArtTagIds } : {})
      }
    },
    {
      name: DesignerTab.manager_units,
      entityType: 'organizations',
      isOverride: true,
      filter: {
        isServiceTeam: false,
        moderationTypes: profileOrganizationsModerationTypes,
        ownerIds: [id],
        ...(isMe ? { statuses: [0,2,4,5,6] } : { statuses: [0]}),
        
      }
    },
    {
      name: DesignerTab.organizations,
      entityType: 'organizations',
      isOverride: true,
      filter: {
        isServiceTeam: false,
        moderationTypes: profileOrganizationsModerationTypes,
        memberIds: [id],
        
      }
    },
    {
      name: DesignerTab.jury,
      entityType: 'jury',
      isOverride: true,
      filter: {
        byJuryIds: [id],
        includeRatings: true,
        competitionStatus: [STATUSES.Open, STATUSES.Voting, STATUSES.Summarizing, STATUSES.Completed],
        sort: 0,
      }
    },
    ...(personalTagId ? [
      {
        name: DesignerTab.aboutMe,
        entityType: 'aboutMe',
        filter: {
          tagIds: [personalTagId],
          // authorIds: [id],
          status: 1,
          isContextIgnored: true
        }
      },
    ] : []),
    {
      name: DesignerTab.discount,
      entityType: 'discount',
      filter: {
        ...commonFilter,
        accountId: id,
      }
    },
    {
      name: DesignerTab.competitionCerts,
      entityType: 'competitionCerts',
      filter: {
        ...commonFilter,
        accountId: id,
      }
    },
      {
        name: DesignerTab.subscribe,
        entityType: 'subscribe',
        filter: {
          accountId: id
        },
        isOverride: true,
        isSwitcher: true
      },
      {
        name: DesignerTab.subscribers,
        entityType: 'subscribers',
        filter: {
          accountId: id
        },
        isOverride: true,
      },
      {
        name: DesignerTab.subscriptions,
        entityType: 'subscriptions',
        filter: {
          accountId: id
        },
        isOverride: true,
      },
      {
        name: DesignerTab.educationSubscribes,
        entityType: 'educationSubscribes',
        path: DesignerTab.educationSubscribes,
        filter: {
          accountId: id,
          moderationTypes: [ 
            ModerationType.ChannelGroupOrCourse],
            statuses: [0, 3], 
            ownerOrMemberIds: [id]  
        },
        isOverride: true,
      },
      {
        name: DesignerTab.subscriptionsTeams,
        entityType: DesignerTab.subscriptionsTeams,
        path: DesignerTab.subscriptionsTeams,
        filter: {
          accountId: id,
          sort: 6
        },
        isOverride: true,
      },
    ...(isMe ? [
      ...(replaceCompetitionsToPractices ? [
        {
          name: DesignerTab.practices,
          entityType: 'practices',
          isOverride: true,
          filter: {
            competitionTypes : [COMPETITION_TYPE.Practices]
          }
        }
      ] : [
        {
        name: DesignerTab.competitions,
        entityType: 'competitions',
        isOverride: true,
        filter: {
        }
      }]),
      {
        name: DesignerTab.draftBooks,
        entityType: 'books',
        isDrafts: true,
        filter: {
          isContextIgnored: true,
          ...commonFilter,
          authorIds: [id],
          bookStatus: [0],
          onlyBooks: true,
        }
      },
      {
        name: DesignerTab.drafts,
        isDrafts: true,
        entityType: 'projects',
        filter: {
          isContextIgnored: true,
          ...commonFilter,
          authorIds: [id],
          projectStatus: [0],
          contextsNotContains: [
            'lmshseproject',
            'lmsproject',
            'lmshse'
          ]
        }
      },
      {
        name: DesignerTab.bannedProjects,
        entityType: 'projects',
        filter: {
          authorIds: [id],
          projectStatus: [3],
          isContextIgnored: true,
          onlyBooks: ''
        }
      },
      {
        name: DesignerTab.lmsDrafts,
        // isDrafts: true,
        entityType: 'projects',
        filter: {
          contexts:[
            'lmshseproject',
            'lmsproject',
            'lmshse'
          ],
          authorIds: [id],
          projectStatus: [0],
        }
      },
      {
        name: DesignerTab.bookmarks,
        entityType: 'projects',
        filter: {
          isContextIgnored: true,
          ...commonFilter,
          onlyBookmarks: true,
          projectStatus: [1, 9],
        }
      },
      {
        name: DesignerTab.private,
        entityType: 'projects',
        filter: {
          ...commonFilter,
          authorIds: [id],
          projectStatus: [10],
          isContextIgnored: true,
          entityType: 'private_projects',
          onlyBooks: '',
        }
      },
      {
        name: DesignerTab.lms,
        entityType: 'projects',
        filter: {
          ...commonFilter,
          contexts: ['lmsproject', 'lmshseproject'],
          projectStatus: [11],
          authorIds: [id],
          isContextIgnored: false,
        }
      },
      {
        name: DesignerTab.underModeration,
        entityType: 'projects',
        filter: {
          ...commonFilter,
          authorIds: [id],
          projectStatus: [5],
        }
      }
    ] : []),
    ...(hasPersonalTags ? [{
      name: DesignerTab.personalTag,
      entityType: 'personalTag',
      isOverride: true,
      isSwitcher: true,
      isLink: true,
      filter: {}
    }] : []),
  ]
}

export const getCommonDesignerTabsFilters = (props: Pick<GetTabs, 'isAgeyTomesh' | 'showcase'>) => {
  const { isAgeyTomesh, showcase } = props
  return {
    isLite: true,
    ...(isAgeyTomesh && { isContextIgnored: false }),
    appNameIgnore: true,
    limit: 20,
    ...(!isAgeyTomesh && showcase && { contexts: ['hsedesign'], isContextIgnored: false}),
    ...(isAgeyTomesh? {contexts: ['ageytomesh']} : {})
  }
}

export const getSuperPuperTabsFilter = () => ({
  isLite: true,
  appNameIgnore: true,
  contexts: ["super-puper-collection"],
  projectFilter: 18,
  limit: 20,
})

const useProfileTabs = (
  designer?: Designer,
  tagId?: any,
  showcase?: boolean,
  activeTab?: string,
  setHasShowcaseProjects?: (flag: boolean) => void,
  isExportPage?: boolean,
) => {
    const { accountId: id = '' } = designer || {};
    const { personalizedTags, isFetching: isPersonalTagsFetching } = useGetPersonalizedTag(id);
    const hasPersonalTags = !isPersonalTagsFetching && personalizedTags?.length > 0;
    const profile = useProfile();
    const isMe = useMemo(() => (profile?.nickName === id || profile?.accountId === id), [profile, id])
    const {
      isHseSpace,
      isStartHSE,
      isExamHSE: isExams,
      isHSEDesign: isHSE,
      isGreenAward,
      isGalllleryArt,
      isMediiia: isMedia,
      isSuperPuper,
      isAgeytomesh: isAgeyTomesh,
      isKiiidsArt,
      isMediiiaProf
    } = useAppTester();
    const isTeacher = useMemo(() => {
      return designer?.globalTypes?.includes('Employee');
    }, [designer])
    const [tabsCount, setTabsCount] = useState({});
    const [tabsLoading, setTabsLoading] = useState(true);
    const [error, setError] = useState(false);
    const [time, setTime] = useState(0);

    const neededTagIds = useMemo(() => 
      [BASE_COURSE_MODERN_DESIGN_TAG_ID, VIDEO_ART_TAG_ID, FINE_ART_TAG_ID, DIGITAL_ART_TAG_ID, CANTEMPORARY_ART_TAG_ID, CINEMA_TAG_ID]
      , [])

    const personalTagId: string | undefined = useMemo(
      //@ts-ignore
      () => (designer && !!designer?.personalTagId) ? designer?.personalTagId : undefined 
    , [designer])

    const replaceCompetitionsToPractices = useMemo(() => {
      return isMediiiaProf
    }, [isMediiiaProf]);

    const superPuperFilter = useMemo(() => getSuperPuperTabsFilter(), []);

    const commonFilter = useMemo(() => {
      const filters = getCommonDesignerTabsFilters({ isAgeyTomesh });
      return {
        ...filters,
        ...(isExportPage ? { limit: EXPORT_PAGE_PROJECTS_GRID_LIMIT } : {}),
        ...(isHSE && !isExams ? {
          globalTypes: [
            'student',
            'hsealumni',
            'Student',
            'Employee',
            'Cooperator',
            ...(isHseSpace ? ['externalhse'] : []),
            ...(isStartHSE ? ['hsestartjunior'] : [])
          ]
        } : {})
      };
    }, [isAgeyTomesh, isExportPage, isHSE, isExams, isHseSpace, isStartHSE]);

    const tabs = useMemo(() => {
      const rawTabs = getDesignerTabsFilters({
        isHseSpace,
        commonFilter,
        id, 
        isAgeyTomesh, 
        isGalllleryArt,
        personalTagId, 
        isMe, 
        isMedia, 
        isSuperPuper, 
        isTeacher, 
        superPuperFilter, 
        tagId, 
        profile: !!profile, 
        showcase, 
        activeTab,
        isExportPage,
        isKiiidsArt,
        replaceCompetitionsToPractices,
        hasPersonalTags,
      });
      
      return rawTabs?.filter((tab) => {
        if (isGreenAward || AppTester.isAKI() || AppTester.isGeoDafes()) {
          return tab.entityType !== DesignerTab.discount
        }
        return tab
      }  ).map(tab => {
        if (tab.entityType === 'projects') {
          const projectStatus = tab.filter.projectStatus;
          if (projectStatus && !arraysIntersect(projectStatus, [0, 10])) {
            return {
              ...tab,
              filter: {
                ...tab.filter,
                isProfile: [DesignerTab.bannedProjects, DesignerTab.private].includes(tab.name) ? false : true,
              }
            };
          }
        }
        return tab;
      });
    }, [isSuperPuper, commonFilter, id, isMe, time, isMedia, isGalllleryArt, personalTagId, tagId, showcase, activeTab, isExportPage, isKiiidsArt, hasPersonalTags]);

    useEffect(() => {
      setError(false);
      setTabsLoading(true);

      if (AppTester.isFtbl()) {
        if (!id) {
          setTabsCount({ [DesignerTab.predictions]: 0 });
          setTabsLoading(false);
          return;
        }

        ftblApi()
          .getPredictions({ accountId: id, page: 1, limit: 1 })
          .then((data) => {
            setTabsCount({ [DesignerTab.predictions]: data?.paging?.count ?? 0 });
          })
          .catch(() => {
            setTabsCount({ [DesignerTab.predictions]: 0 });
          })
          .finally(() => {
            setTabsLoading(false);
          });
        return;
      }

      const tabsItems = Object.entries(tabs ?? {}).map(([k, value]) => {
        const item = {...value};
        const newFilter = { ...item?.filter ?? {} };
        
        if (newFilter.statuses && item?.name === DesignerTab.manager_units) {
          newFilter.teamStatus = newFilter.statuses;
          delete newFilter.statuses;
        }
      
        return { ...item, filter: newFilter }; 
      });

      API
        .request()
        .endpoint(Endpoints.geograffee)
        .url('/api/Designer/GetTabsItemsCount')
        .body({
          tabs: tabsItems,
        })
        .post()
        .release()
        .then((r) => {
          const count = r?.tabs?.reduce((acc: any, { name, count, entityType }: any) => {
            if (entityType === 'personalTag') {
              return {
                ...acc,
                [name]: 1,
              }
            }
            const isWorkingMaterials = [
              DesignerTab.workingMaterialsAuthor,
              DesignerTab.workingMaterialsStudents,
              DesignerTab.workingMaterialsCoauthor,
            ].includes(name);
            return {
              ...acc,
              ...(isWorkingMaterials
                ? { [DesignerTab.workingMaterials]: (acc[DesignerTab.workingMaterials] || 0) + count }
                : {}),
              [name]: count,
            }
          }, {
            // [DesignerTab.competitions]: 15,
          })

          if (['projects', 'coauthor', 'students']?.includes(activeTab ?? '')) {
            const currentTab = tabs?.find(({ name }) => name === activeTab)
            
            API
            .request()
            .endpoint(Endpoints.geograffee)
            .url('/api/Designer/GetTabsItemsCount')
            .body({
              tabs: [
                {
                  ...currentTab, 
                  filter: {
                    ...(currentTab && currentTab.filter), 
                    contexts: ['hsedesign'],
                    isContextIgnored: false
                  } 
                }
              ]
            })
            .post()
            .release()
            .then((r) => {

              setHasShowcaseProjects && setHasShowcaseProjects(r?.tabs?.[0]?.count > 0)
            })
          } 

          setTabsCount(count || {});
          setTabsLoading(false);
        });
    }, [tabs, id])

    const tabsFormatted = useMemo(() => {
      if (!Object.keys(tabsCount)?.length) {
        return []
      }
      
      return tabs.reduce((acc: any[], tab: any) => {
        const {
          entityType,
          name,
          filter: {
            bookStatus,
            projectStatus,
            ...filter
          }
        } = tab;
        //@ts-ignore
        if (tabsCount[name] > 0 || 'draft_books') {
          const formattedTab = {
            ...tab,
            path: name,
            entityType,
            filter: {
              tabName: name,
              ...filter,
              ...(bookStatus || projectStatus ? { projectStatus: bookStatus || projectStatus } : {}),
            }
          }
          return [...acc, formattedTab]
        }
        return acc;
      }, [])
    }, [neededTagIds, tabsCount])

    const updateTabs = useCallback(() => {
      setTime(Date.now())
    }, [setTime])

  return {
      counts: tabsCount,
      tabsFormatted,
      tabsLoading,
      loadingError: error,
      commonFilter,
      updateTabs,
      personalizedTags,
    };
  }
;

export default useProfileTabs;import { useCallback, useEffect, useMemo, useState } from "react";
import { API, Designer, Endpoints } from "@brg/api";
import { useProfile } from "@brg/auth";
import { DesignerTab } from "../constants/designerTab";
import { AppTester } from "../../supporting";
import {
  BASE_COURSE_MODERN_DESIGN_TAG_ID,
  CANTEMPORARY_ART_TAG_ID,
  CINEMA_TAG_ID,
  DIGITAL_ART_TAG_ID,
  EXPORT_PAGE_PROJECTS_GRID_LIMIT,
  FINE_ART_TAG_ID,
  VIDEO_ART_TAG_ID,
  GALLLLERY_ART_DIGITAL_COLLECTIONS_TAG_ID,
  GALLLLERY_ART_COLLECTIONS_TAG_ID,
  GALLLLERY_ART_COLLECTING_TAG_ID,
  GALLLLERY_ART_ABOUT_COLLECTIONS_TAG_ID,
  KIIIDS_ART_PROFILE_TAG_IDS,
} from "../constants/misc";
import {COMPETITION_TYPE, STATUSES} from "../../_competition/const";
import { ModerationType } from "shared/pages/teams/const/ModerationTypes";
import arraysIntersect from "shared/helpers/arraysIntersect";
import { ftblApi } from "../api/ftblApi";
import useAppTester from "shared/MobileMenu/hooks/useAppTester";
import { useGetPersonalizedTag } from "./api/useGetPersonalizedTag";

interface GetTabs {
  id: string, 
  commonFilter: any,  
  superPuperFilter: any , 
  isSuperPuper: boolean, 
  isMe: boolean, 
  isTeacher?: boolean, 
  isAgeyTomesh: boolean, 
  isMedia?: boolean,
  isGalllleryArt?: boolean,
  tagId: string,
  profile?: boolean,
  showcase?: boolean,
  activeTab?: string,
  personalTagId?: string,
  isHseSpace?: boolean,
  isExportPage?: boolean,
  isKiiidsArt?: boolean,
  replaceCompetitionsToPractices?: boolean,
  hasPersonalTags?: boolean,
}

export const getDesignerTabsFilters = (props: GetTabs) => {
  const {
    commonFilter,
    id,
    personalTagId, 
    isMe, 
    isSuperPuper, 
    isTeacher, 
    superPuperFilter, 
    isAgeyTomesh, 
    isMedia,
    isHseSpace,
    isGalllleryArt,
    tagId, 
    profile, 
    showcase, 
    activeTab,
    isExportPage,
    isKiiidsArt,
    replaceCompetitionsToPractices,
    hasPersonalTags,
  } = props

  const galllleryArtTagIds = [
    GALLLLERY_ART_DIGITAL_COLLECTIONS_TAG_ID,
    GALLLLERY_ART_COLLECTIONS_TAG_ID,
    GALLLLERY_ART_COLLECTING_TAG_ID,
    GALLLLERY_ART_ABOUT_COLLECTIONS_TAG_ID
  ];    

  if (isExportPage) {
    return [
      {
        name: DesignerTab.author,
        entityType: 'projects',
        filter: {
          ...commonFilter,
          isMainAuthor: true,
          authorIds: [id],
          projectStatus: [1],
          isContextIgnored: true,
          ...(activeTab === DesignerTab.author && { ...(!!showcase && {
            contexts: isAgeyTomesh ? ['ageytomesh'] : ['hsedesign'],
            isContextIgnored: false,
          })}),
          ...(tagId ? { tagIds: [tagId] } : isGalllleryArt ? { tagIds: galllleryArtTagIds } : {}),
        },
      },
      ...(isMe
        ? [
            {
              name: DesignerTab.private,
              entityType: 'projects',
              filter: {
                ...commonFilter,
                authorIds: [id],
                projectStatus: [10],
                isContextIgnored: true,
                entityType: 'private_projects',
                onlyBooks: '',
              },
            },
          ]
        : []),
    ];
  }

  if (isSuperPuper) {
    return [
      {
        name: DesignerTab.games_archive,
        entityType: 'projects',
        filter: {
          ...superPuperFilter,
          authorIds: [id],
          projectStatus: [1],
          onlyAuthors: true
        }
      },
      ...(isMe ? [{
        name: DesignerTab.games_drafts,
        entityType: 'projects',
        filter: {
          ...superPuperFilter,
          authorIds: [id],
          projectStatus: [0],
          onlyAuthors: true
        }
      }] : [])]
  }

  if (isKiiidsArt) {
    return [
      {
        name: DesignerTab.author,
        entityType: 'projects',
        filter: {
          ...commonFilter,
          authorIds: [id],
          projectStatus: [1],
          isContextIgnored: true,
          tagIds: KIIIDS_ART_PROFILE_TAG_IDS,
        },
      },
      {
        name: DesignerTab.books,
        entityType: 'books',
        filter: {
          ...commonFilter,
          authorIds: [id],
          bookStatus: [1],
          onlyBooks: true,
          isContextIgnored: true,
          tagIds: KIIIDS_ART_PROFILE_TAG_IDS,
        },
      },
    ];
  }

  const profileOrganizationsModerationTypes = [
    ModerationType.Own,
    ModerationType.OwnWithoutTag,
    ModerationType.Outer,
    ModerationType.Standard,
    ModerationType.StandardWithoutTag,
    ModerationType.Hsedesign
  ];

  return [
    {
      name: DesignerTab.author,
      entityType: 'projects',
      filter: {
        ...commonFilter,
        // isContextIgnored: false,
        authorIds: [id],
        // isMainAuthor: true,
        projectStatus: [1],
        isContextIgnored: true,
        ...(activeTab === DesignerTab.author && { ...(!!showcase && {
          contexts: isAgeyTomesh ? ['ageytomesh'] : ['hsedesign'], 
          isContextIgnored: false,
        })}),
        ...(tagId ? { tagIds: [tagId] } : isGalllleryArt ? { tagIds: galllleryArtTagIds } : {})
      }
    },
    ...(isTeacher ? [{
      name: DesignerTab.students,
      entityType: 'projects',
      filter: {
        ...commonFilter,
        curatorsIdList: [id],
        projectStatus: [1],
        isContextIgnored: true,
        ...(activeTab === DesignerTab.students && { ...(!!showcase && {
          contexts: isAgeyTomesh ? ['ageytomesh'] : ['hsedesign'], 
          isContextIgnored: false,
        })}),
      }
    }
    ] : []),
    {
      name: DesignerTab.books,
      entityType: 'books',
      filter: {
        ...commonFilter,
        authorIds: [id],
        bookStatus: [1],
        onlyBooks: true,
        isContextIgnored: true,
        // ...(isGalllleryArt ? { tagIds: galllleryArtTagIds } : {})
      }
    },
    {
      name: DesignerTab.manager_units,
      entityType: 'organizations',
      isOverride: true,
      filter: {
        isServiceTeam: false,
        moderationTypes: profileOrganizationsModerationTypes,
        ownerIds: [id],
        ...(isMe ? { statuses: [0,2,4,5,6] } : { statuses: [0]}),
        
      }
    },
    {
      name: DesignerTab.organizations,
      entityType: 'organizations',
      isOverride: true,
      filter: {
        isServiceTeam: false,
        moderationTypes: profileOrganizationsModerationTypes,
        memberIds: [id],
        
      }
    },
    {
      name: DesignerTab.jury,
      entityType: 'jury',
      isOverride: true,
      filter: {
        byJuryIds: [id],
        includeRatings: true,
        competitionStatus: [STATUSES.Open, STATUSES.Voting, STATUSES.Summarizing, STATUSES.Completed],
        sort: 0,
      }
    },
    ...(personalTagId ? [
      {
        name: DesignerTab.aboutMe,
        entityType: 'aboutMe',
        filter: {
          tagIds: [personalTagId],
          // authorIds: [id],
          status: 1,
          isContextIgnored: true
        }
      },
    ] : []),
    {
      name: DesignerTab.discount,
      entityType: 'discount',
      filter: {
        ...commonFilter,
        accountId: id,
      }
    },
    {
      name: DesignerTab.competitionCerts,
      entityType: 'competitionCerts',
      filter: {
        ...commonFilter,
        accountId: id,
      }
    },
      {
        name: DesignerTab.subscribe,
        entityType: 'subscribe',
        filter: {
          accountId: id
        },
        isOverride: true,
        isSwitcher: true
      },
      {
        name: DesignerTab.subscribers,
        entityType: 'subscribers',
        filter: {
          accountId: id
        },
        isOverride: true,
      },
      {
        name: DesignerTab.subscriptions,
        entityType: 'subscriptions',
        filter: {
          accountId: id
        },
        isOverride: true,
      },
      {
        name: DesignerTab.educationSubscribes,
        entityType: 'educationSubscribes',
        path: DesignerTab.educationSubscribes,
        filter: {
          accountId: id,
          moderationTypes: [ 
            ModerationType.ChannelGroupOrCourse],
            statuses: [0, 3], 
            ownerOrMemberIds: [id]  
        },
        isOverride: true,
      },
      {
        name: DesignerTab.subscriptionsTeams,
        entityType: DesignerTab.subscriptionsTeams,
        path: DesignerTab.subscriptionsTeams,
        filter: {
          accountId: id,
          sort: 6
        },
        isOverride: true,
      },
    ...(isMe ? [
      ...(replaceCompetitionsToPractices ? [
        {
          name: DesignerTab.practices,
          entityType: 'practices',
          isOverride: true,
          filter: {
            competitionTypes : [COMPETITION_TYPE.Practices]
          }
        }
      ] : [
        {
        name: DesignerTab.competitions,
        entityType: 'competitions',
        isOverride: true,
        filter: {
        }
      }]),
      {
        name: DesignerTab.draftBooks,
        entityType: 'books',
        isDrafts: true,
        filter: {
          isContextIgnored: true,
          ...commonFilter,
          authorIds: [id],
          bookStatus: [0],
          onlyBooks: true,
        }
      },
      {
        name: DesignerTab.drafts,
        isDrafts: true,
        entityType: 'projects',
        filter: {
          isContextIgnored: true,
          ...commonFilter,
          authorIds: [id],
          projectStatus: [0],
          contextsNotContains: [
            'lmshseproject',
            'lmsproject',
            'lmshse'
          ]
        }
      },
      {
        name: DesignerTab.bannedProjects,
        entityType: 'projects',
        filter: {
          authorIds: [id],
          projectStatus: [3],
          isContextIgnored: true,
          onlyBooks: ''
        }
      },
      {
        name: DesignerTab.lmsDrafts,
        // isDrafts: true,
        entityType: 'projects',
        filter: {
          contexts:[
            'lmshseproject',
            'lmsproject',
            'lmshse'
          ],
          authorIds: [id],
          projectStatus: [0],
        }
      },
      {
        name: DesignerTab.bookmarks,
        entityType: 'projects',
        filter: {
          isContextIgnored: true,
          ...commonFilter,
          onlyBookmarks: true,
          projectStatus: [1, 9],
        }
      },
      {
        name: DesignerTab.private,
        entityType: 'projects',
        filter: {
          ...commonFilter,
          authorIds: [id],
          projectStatus: [10],
          isContextIgnored: true,
          entityType: 'private_projects',
          onlyBooks: '',
        }
      },
      {
        name: DesignerTab.lms,
        entityType: 'projects',
        filter: {
          ...commonFilter,
          contexts: ['lmsproject', 'lmshseproject'],
          projectStatus: [11],
          authorIds: [id],
          isContextIgnored: false,
        }
      },
      {
        name: DesignerTab.underModeration,
        entityType: 'projects',
        filter: {
          ...commonFilter,
          authorIds: [id],
          projectStatus: [5],
        }
      }
    ] : []),
    ...(hasPersonalTags ? [{
      name: DesignerTab.personalTag,
      entityType: 'personalTag',
      isOverride: true,
      isSwitcher: true,
      isLink: true,
      filter: {}
    }] : []),
  ]
}

export const getCommonDesignerTabsFilters = (props: Pick<GetTabs, 'isAgeyTomesh' | 'showcase'>) => {
  const { isAgeyTomesh, showcase } = props
  return {
    isLite: true,
    ...(isAgeyTomesh && { isContextIgnored: false }),
    appNameIgnore: true,
    limit: 20,
    ...(!isAgeyTomesh && showcase && { contexts: ['hsedesign'], isContextIgnored: false}),
    ...(isAgeyTomesh? {contexts: ['ageytomesh']} : {})
  }
}

export const getSuperPuperTabsFilter = () => ({
  isLite: true,
  appNameIgnore: true,
  contexts: ["super-puper-collection"],
  projectFilter: 18,
  limit: 20,
})

const useProfileTabs = (
  designer?: Designer,
  tagId?: any,
  showcase?: boolean,
  activeTab?: string,
  setHasShowcaseProjects?: (flag: boolean) => void,
  isExportPage?: boolean,
) => {
    const { accountId: id = '' } = designer || {};
    const { personalizedTags, isFetching: isPersonalTagsFetching } = useGetPersonalizedTag(id);
    const hasPersonalTags = !isPersonalTagsFetching && personalizedTags?.length > 0;
    const profile = useProfile();
    const isMe = useMemo(() => (profile?.nickName === id || profile?.accountId === id), [profile, id])
    const {
      isHseSpace,
      isStartHSE,
      isExamHSE: isExams,
      isHSEDesign: isHSE,
      isGreenAward,
      isGalllleryArt,
      isMediiia: isMedia,
      isSuperPuper,
      isAgeytomesh: isAgeyTomesh,
      isKiiidsArt,
      isMediiiaProf
    } = useAppTester();
    const isTeacher = useMemo(() => {
      return designer?.globalTypes?.includes('Employee');
    }, [designer])
    const [tabsCount, setTabsCount] = useState({});
    const [tabsLoading, setTabsLoading] = useState(true);
    const [error, setError] = useState(false);
    const [time, setTime] = useState(0);

    const neededTagIds = useMemo(() => 
      [BASE_COURSE_MODERN_DESIGN_TAG_ID, VIDEO_ART_TAG_ID, FINE_ART_TAG_ID, DIGITAL_ART_TAG_ID, CANTEMPORARY_ART_TAG_ID, CINEMA_TAG_ID]
      , [])

    const personalTagId: string | undefined = useMemo(
      //@ts-ignore
      () => (designer && !!designer?.personalTagId) ? designer?.personalTagId : undefined 
    , [designer])

    const replaceCompetitionsToPractices = useMemo(() => {
      return isMediiiaProf
    }, [isMediiiaProf]);

    const superPuperFilter = useMemo(() => getSuperPuperTabsFilter(), []);

    const commonFilter = useMemo(() => {
      const filters = getCommonDesignerTabsFilters({ isAgeyTomesh });
      return {
        ...filters,
        ...(isExportPage ? { limit: EXPORT_PAGE_PROJECTS_GRID_LIMIT } : {}),
        ...(isHSE && !isExams ? {
          globalTypes: [
            'student',
            'hsealumni',
            'Student',
            'Employee',
            'Cooperator',
            ...(isHseSpace ? ['externalhse'] : []),
            ...(isStartHSE ? ['hsestartjunior'] : [])
          ]
        } : {})
      };
    }, [isAgeyTomesh, isExportPage, isHSE, isExams, isHseSpace, isStartHSE]);

    const tabs = useMemo(() => {
      const rawTabs = getDesignerTabsFilters({
        isHseSpace,
        commonFilter,
        id, 
        isAgeyTomesh, 
        isGalllleryArt,
        personalTagId, 
        isMe, 
        isMedia, 
        isSuperPuper, 
        isTeacher, 
        superPuperFilter, 
        tagId, 
        profile: !!profile, 
        showcase, 
        activeTab,
        isExportPage,
        isKiiidsArt,
        replaceCompetitionsToPractices,
        hasPersonalTags,
      });
      
      return rawTabs?.filter((tab) => {
        if (isGreenAward || AppTester.isAKI() || AppTester.isGeoDafes()) {
          return tab.entityType !== DesignerTab.discount
        }
        return tab
      }  ).map(tab => {
        if (tab.entityType === 'projects') {
          const projectStatus = tab.filter.projectStatus;
          if (projectStatus && !arraysIntersect(projectStatus, [0, 10])) {
            return {
              ...tab,
              filter: {
                ...tab.filter,
                isProfile: [DesignerTab.bannedProjects, DesignerTab.private].includes(tab.name) ? false : true,
              }
            };
          }
        }
        return tab;
      });
    }, [isSuperPuper, commonFilter, id, isMe, time, isMedia, isGalllleryArt, personalTagId, tagId, showcase, activeTab, isExportPage, isKiiidsArt, hasPersonalTags]);

    useEffect(() => {
      setError(false);
      setTabsLoading(true);

      if (AppTester.isFtbl()) {
        if (!id) {
          setTabsCount({ [DesignerTab.predictions]: 0 });
          setTabsLoading(false);
          return;
        }

        ftblApi()
          .getPredictions({ accountId: id, page: 1, limit: 1 })
          .then((data) => {
            setTabsCount({ [DesignerTab.predictions]: data?.paging?.count ?? 0 });
          })
          .catch(() => {
            setTabsCount({ [DesignerTab.predictions]: 0 });
          })
          .finally(() => {
            setTabsLoading(false);
          });
        return;
      }

      const tabsItems = Object.entries(tabs ?? {}).map(([k, value]) => {
        const item = {...value};
        const newFilter = { ...item?.filter ?? {} };
        
        if (newFilter.statuses && item?.name === DesignerTab.manager_units) {
          newFilter.teamStatus = newFilter.statuses;
          delete newFilter.statuses;
        }
      
        return { ...item, filter: newFilter }; 
      });

      API
        .request()
        .endpoint(Endpoints.geograffee)
        .url('/api/Designer/GetTabsItemsCount')
        .body({
          tabs: tabsItems,
        })
        .post()
        .release()
        .then((r) => {
          const count = r?.tabs?.reduce((acc: any, { name, count, entityType }: any) => {
            if (entityType === 'personalTag') {
              return {
                ...acc,
                [name]: 1,
              }
            }
            const isWorkingMaterials = [
              DesignerTab.workingMaterialsAuthor,
              DesignerTab.workingMaterialsStudents,
              DesignerTab.workingMaterialsCoauthor,
            ].includes(name);
            return {
              ...acc,
              ...(isWorkingMaterials
                ? { [DesignerTab.workingMaterials]: (acc[DesignerTab.workingMaterials] || 0) + count }
                : {}),
              [name]: count,
            }
          }, {
            // [DesignerTab.competitions]: 15,
          })

          if (['projects', 'coauthor', 'students']?.includes(activeTab ?? '')) {
            const currentTab = tabs?.find(({ name }) => name === activeTab)
            
            API
            .request()
            .endpoint(Endpoints.geograffee)
            .url('/api/Designer/GetTabsItemsCount')
            .body({
              tabs: [
                {
                  ...currentTab, 
                  filter: {
                    ...(currentTab && currentTab.filter), 
                    contexts: ['hsedesign'],
                    isContextIgnored: false
                  } 
                }
              ]
            })
            .post()
            .release()
            .then((r) => {

              setHasShowcaseProjects && setHasShowcaseProjects(r?.tabs?.[0]?.count > 0)
            })
          } 

          setTabsCount(count || {});
          setTabsLoading(false);
        });
    }, [tabs, id])

    const tabsFormatted = useMemo(() => {
      if (!Object.keys(tabsCount)?.length) {
        return []
      }
      
      return tabs.reduce((acc: any[], tab: any) => {
        const {
          entityType,
          name,
          filter: {
            bookStatus,
            projectStatus,
            ...filter
          }
        } = tab;
        //@ts-ignore
        if (tabsCount[name] > 0 || 'draft_books') {
          const formattedTab = {
            ...tab,
            path: name,
            entityType,
            filter: {
              tabName: name,
              ...filter,
              ...(bookStatus || projectStatus ? { projectStatus: bookStatus || projectStatus } : {}),
            }
          }
          return [...acc, formattedTab]
        }
        return acc;
      }, [])
    }, [neededTagIds, tabsCount])

    const updateTabs = useCallback(() => {
      setTime(Date.now())
    }, [setTime])

  return {
      counts: tabsCount,
      tabsFormatted,
      tabsLoading,
      loadingError: error,
      commonFilter,
      updateTabs,
      personalizedTags,
    };
  }
;

export default useProfileTabs;